import { render, staticRenderFns } from "./BridgeDisclaimerMobile.vue?vue&type=template&id=4f00d58e"
import script from "./BridgeDisclaimerMobile.vue?vue&type=script&lang=ts"
export * from "./BridgeDisclaimerMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports